import { DialogPortal } from "@/components/ui/dialog";
import { cn } from "@/lib/utils";
import type { ComponentPropsWithoutRef } from "react";
import type * as DialogPrimitive from "@radix-ui/react-dialog";

/** Gray overlay for ticket create/edit when Dialog `modal={false}` (Radix skips default overlay). */
export function TicketDialogBackdrop({
  open,
  className,
}: {
  open: boolean;
  className?: string;
}) {
  if (!open) return null;

  return (
    <DialogPortal>
      <div
        aria-hidden="true"
        className={cn(
          "fixed inset-0 z-[49] bg-slate-900/45 backdrop-blur-[2px] animate-in fade-in-0 duration-200",
          className
        )}
      />
    </DialogPortal>
  );
}

/** Only the explicit Close button should dismiss — not backdrop, Escape, or outside click. */
export function preventTicketDialogDismiss(): Pick<
  ComponentPropsWithoutRef<typeof DialogPrimitive.Content>,
  "onInteractOutside" | "onPointerDownOutside" | "onEscapeKeyDown"
> {
  return {
    onInteractOutside: e => e.preventDefault(),
    onPointerDownOutside: e => e.preventDefault(),
    onEscapeKeyDown: e => e.preventDefault(),
  };
}

export function ticketDialogOpenChangeHandler(
  onOpenChange: (open: boolean) => void
) {
  return (next: boolean) => {
    if (next) onOpenChange(true);
  };
}
